// extracted by mini-css-extract-plugin
export default {"row":"Vu3couXEOhA7VfCIJjTX","tag":"NUbgyGbkP9AXjPJZu0QR","tags":"EdTZkJyuCWiLt3u0oRTk jB3NvNkGLdV_Z2_JWnAA"};